import { render, staticRenderFns } from "./LayoutSteps.vue?vue&type=template&id=36a089da&scoped=true&"
var script = {}
import style0 from "./LayoutSteps.vue?vue&type=style&index=0&id=36a089da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a089da",
  null
  
)

export default component.exports